/**
 * React Query key factory — **espace externe** (EPIC 49_PORT).
 *
 * PORT-008 §6.2 couche 4. Deux clés seulement au socle : l'habillage public
 * (avant connexion) et `/me` (après).
 *
 * ⚠️ Ces clés ne portent **aucun identifiant de personne**. `/me` est indexée
 * par le cookie de session, pas par un `user_id` : un espace n'affiche jamais
 * qu'une identité à la fois, et mettre l'identifiant dans la clé ferait
 * cohabiter deux caches sur un même navigateur après un changement de compte.
 *
 * ⚠️ `branding` est indexée par le **sous-domaine**, non par une constante :
 * en développement, plusieurs organismes se servent depuis le même navigateur
 * (`of1.localhost`, `of2.localhost`), et une clé constante servirait le logo
 * du précédent.
 */

const portalAll = ['portal'] as const

export const portalKeys = {
    portal: {
        all: portalAll,
        /** L'habillage public — avant toute session (PORT-008 §7). */
        branding: () => [...portalAll, 'branding', window.location.host] as const,
        /** Identité, organisme, contextes et contexte actif (PORT-005 §7). */
        me: () => [...portalAll, 'me'] as const,
        /** PORT-006 §7 — `has_password`, MFA : lu par « Mon compte ». */
        security: () => [...portalAll, 'security'] as const,
    },
} as const
